<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

    


<div class="columns is-multiline is-gapless" style="margin-bottom:0em;">
        <div :class="return_style_select()" @click="click_box()" class="column is-12 is-size-7 colBorderThin isLink hoverIt hoverItBack">
            {{stud.student_lNAME}}
        </div>
</div>






</div>
</template>

<script>
import moment from 'moment';
import { bus } from '@/main'


//, 'sess', 'ann'
export default {
        props: [ 'stud' ],

        data() {
            return {


                isLoading:false,
                is_selected: false,
                tran_selected_id: '',
                type :'OSA'
            }
        },



mounted() {

// CHECK IF SELECTED (SELECT ALL)
    // if (this.stud.isSelected == 1) {this.hop_on_tran_bus('C')}
    // else {this.hop_on_tran_bus()}



}, // END CREATED

methods : { 


return_style_select:function() {

    if (this.stud.isSelected == 1) {return 'has-background-success'}
    else {return 'has-background-white'}
},

click_box:function() {
    if (this.stud.isSelected == 0) {this.stud.isSelected = 1 ; this.hop_on_tran_bus('C')}
    else {this.stud.isSelected = 0 ; this.hop_on_tran_bus()}
},


// GENERATE ID FOR TRANSACTION -- SAVE TO DB (NEW) 
    randomTran_ID:function() {

        return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
    });},

// WHAT ABOUT REMOVAL !!!! 
    hop_on_tran_bus:function (op){ 
        this.is_selected=true; 
        this.tran_selected_id = this.type + this.randomTran_ID()
        bus.$emit('hop_on_for_tran', this.stud , this.type , op , this.tran_selected_id );
    },

    hop_off_tran_bus:function () {
        this.is_selected=false;
        bus.$emit('hop_off_for_tran', this.tran_selected_id , this.type);
    },












}, // END METHODS


}
</script>